const reducer = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_COLORWAY_SUCCESS':
      return action.payload;

    case 'FETCH_COLORWAY_ERROR':
      // Should probably add error logging here
      return state;

    default:
      return state;
  }
};

export default reducer;
